// removed by extract-text-webpack-plugin
module.exports = {"loaderIcon":"Loader_loaderIcon_10P7a","typing":"Loader_typing_3XqNR","right":"Loader_right_1GwCD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Loader/Loader.css
// module id = 114
// module chunks = 0